var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mynote_wrap" }, [
    _c("div", { staticClass: "mynoteList" }, [
      _c(
        "ul",
        [
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "li",
              {
                key: item.id,
                class: { active: _vm.num == index },
                on: {
                  click: function($event) {
                    return _vm.getNum(index)
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(item) + "\n        ")]
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "status_select" },
            [
              _c("span", [_vm._v("状态")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  on: { change: _vm.selectChange },
                  model: {
                    value: _vm.value,
                    callback: function($$v) {
                      _vm.value = $$v
                    },
                    expression: "value"
                  }
                },
                _vm._l(_vm.options, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "line" })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _vm.myNoteData.length
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "mynoteTabCon"
          },
          [
            _c(
              "div",
              {
                staticClass: "mynote-list",
                style: { height: _vm.styleHeight }
              },
              _vm._l(_vm.myNoteData, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "note-list-item" },
                  [
                    _vm._m(0, true),
                    _vm._v(" "),
                    _c("div", { staticClass: "right_portrait" }, [
                      _c("div", { staticClass: "top" }, [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.username))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "time" }, [
                          _vm._v(_vm._s(item.date))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "status",
                            style: _vm.handleStatus(item.noteType)
                          },
                          [_vm._v(_vm._s(item.noteType))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "span",
                            { staticClass: "m-content overflow-line" },
                            [_vm._v(_vm._s(item.content))]
                          ),
                          _vm._v(" "),
                          (item.content.length > 50
                          ? (_vm.isShowMore = true)
                          : (_vm.isShowMore = false))
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "btn-more",
                                  attrs: { type: "text", id: "J_btnmore" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showmoreDesc($event)
                                    }
                                  }
                                },
                                [_vm._v("展开")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "bottom" }, [
                        _c("div", { staticClass: "left" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../../../static/images/study/icon/zhangjie.png")
                            }
                          }),
                          _vm._v(" "),
                          item.catalogName
                            ? _c("span", [_vm._v(_vm._s(item.catalogName))])
                            : _c("span", [_vm._v("全部章节")])
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "right" }, [
                          !item.isUserPraise
                            ? _c(
                                "li",
                                {
                                  staticClass: "dianzan",
                                  on: {
                                    click: function($event) {
                                      return _vm.assist(item.noteId)
                                    }
                                  }
                                },
                                [
                                  _c("div"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(item.notePraiseNumber))
                                  ])
                                ]
                              )
                            : _c(
                                "li",
                                {
                                  staticClass: "y_dianzan",
                                  on: {
                                    click: function($event) {
                                      return _vm.unassist(item.noteId)
                                    }
                                  }
                                },
                                [
                                  _c("div"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(item.notePraiseNumber))
                                  ])
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "pinglun",
                              on: {
                                click: function($event) {
                                  return _vm.getComment(item)
                                }
                              }
                            },
                            [
                              _c("div"),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.replyNumber))])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "note_editor",
                              on: {
                                click: function($event) {
                                  return _vm.editorNote(item)
                                }
                              }
                            },
                            [_c("div")]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "delete",
                              on: {
                                click: function($event) {
                                  return _vm.delNote(item.noteId)
                                }
                              }
                            },
                            [_c("div")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      item.status == 1
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.noteLoading,
                                  expression: "noteLoading"
                                }
                              ],
                              staticClass: "commentCont"
                            },
                            [
                              _c("div", { staticClass: "comment1" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "comment2" }, [
                                _c(
                                  "div",
                                  { staticClass: "comment2_cont" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "pinglun_text" },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            resize: "none",
                                            placeholder: "请输入内容",
                                            maxlength: "300",
                                            "show-word-limit": ""
                                          },
                                          model: {
                                            value: _vm.discussionContent,
                                            callback: function($$v) {
                                              _vm.discussionContent = $$v
                                            },
                                            expression: "discussionContent"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "btn" },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  disabled: _vm.disabledBtn
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.publish(item)
                                                  }
                                                }
                                              },
                                              [_vm._v("发表")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.commentList.length
                                      ? _c("el-divider")
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(_vm.commentList, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "comment-item"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "commentContent" },
                                            [
                                              _vm._v(
                                                "\n\t\t        \t\t\t\t\t" +
                                                  _vm._s(item.replyContent) +
                                                  "\n\t\t        \t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "comment-bottom" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "left" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.userName)
                                                    ),
                                                    item.isTeacherReply
                                                      ? _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "zhiwei"
                                                          },
                                                          [_vm._v("教师")]
                                                        )
                                                      : _vm._e()
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(_vm._s(item.date))
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              item.isDelete
                                                ? _c("div", {
                                                    staticClass: "right",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.delComment(
                                                          item.replyId,
                                                          item.learnId
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comment3" })
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              }),
              0
            )
          ]
        )
      : _c("div", { staticClass: "noData" }, [
          _c("img", {
            attrs: {
              src: require("../../../../../../static/images/wujieguo.png")
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v("暂无相关内容")])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left_portrait" }, [
      _c("img", {
        attrs: {
          src: require("../../../../../../static/images/study/icon/teacher.png")
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66fbd9bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66fbd9bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/note/myNote.vue
// module id = null
// module chunks = 